export default "__VITE_ASSET__Bg_wOyrc__"